import ToastContextInterface, { ToastAction } from '@app/Interface/ToastContextInterface';
import React from 'react';
import { toastNotificationReducer } from '@app/Context/Reducer/ToastNotificationReducer';
import { ToastNotificationType } from '@app/Interface/ToastNotificationInterface';

// based on this example code
// https://elisealcala.com/context-use-reducer-typescript/

const toastNotificationInitialState: ToastContextInterface = {
    toastNotices: []
}

const ToastNotificationContext = React.createContext<{
    toastState: ToastContextInterface;
    toastDispatch: React.Dispatch<ToastAction>;
}>({
    toastState: toastNotificationInitialState,
    toastDispatch: () => null
});


const ToastProvider: React.FC = ({ children }) => {

    const [toastState, toastDispatch] = React.useReducer(toastNotificationReducer, toastNotificationInitialState);

    return (
        <ToastNotificationContext.Provider value={{ toastState, toastDispatch }}>
            {children}
        </ToastNotificationContext.Provider>
    );

}

/**
 * Adds a Toast Notification to application state 
 * 
 * @param toastDispatch 
 * @param notificationType 
 * @param title 
 * @param description 
 */
const CreateToastNotification = (toastDispatch: React.Dispatch<ToastAction>, notificationType: ToastNotificationType, title: string, description: string): void => {

    toastDispatch({
        type: "ADD",
        payload: {
            id: 0,
            title: title,
            type: notificationType,
            description: description
        }
    });

};

export { ToastProvider, ToastNotificationContext, CreateToastNotification }